"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CredsProviderHelpers = exports.CredsProvider = void 0;
var CredsProvider;
(function (CredsProvider) {
    CredsProvider["FACEBOOK"] = "FACEBOOK";
    CredsProvider["FACEBOOKBUSINESS"] = "FACEBOOKBUSINESS";
    CredsProvider["APPLOVIN"] = "APPLOVIN";
    CredsProvider["GOOGLEADS"] = "GOOGLEADS";
    CredsProvider["IRONSOURCE"] = "IRONSOURCE";
    CredsProvider["IRONSOURCECOST"] = "IRONSOURCECOST";
    CredsProvider["IRONSOURCEBUSINESS"] = "IRONSOURCEBUSINESS";
    CredsProvider["IRONSOURCEADREVENUE"] = "IRONSOURCEADREVENUE";
    CredsProvider["ADCOLONY"] = "ADCOLONY";
    CredsProvider["UNITY"] = "UNITY";
    CredsProvider["VUNGLE"] = "VUNGLE";
    CredsProvider["CHARTBOOST"] = "CHARTBOOST";
    CredsProvider["APPLESEARCH"] = "APPLESEARCH";
    CredsProvider["APPLESKAN"] = "APPLESKAN";
    CredsProvider["TAPJOY"] = "TAPJOY";
    CredsProvider["TAPJOYV2"] = "TAPJOYV2";
    CredsProvider["TUNE"] = "TUNE";
    CredsProvider["KOCHAVA"] = "KOCHAVA";
    CredsProvider["KOCHAVAAGGREGATED"] = "KOCHAVAAGGREGATED";
    CredsProvider["LIFESTREET"] = "LIFESTREET";
    CredsProvider["APPLIKE"] = "APPLIKE";
    CredsProvider["DIGITALTURBINE"] = "DIGITALTURBINE";
    CredsProvider["APPLOVINMAX"] = "APPLOVINMAX";
    CredsProvider["APPLOVINUSERREVENUE"] = "APPLOVINUSERREVENUE";
    CredsProvider["APPLOVINPROFIT"] = "APPLOVINPROFIT";
    CredsProvider["ADJUST"] = "ADJUST";
    CredsProvider["ADJUSTMMP"] = "ADJUSTMMP";
    CredsProvider["ADJUSTSKAN"] = "ADJUSTSKAN";
    CredsProvider["ADJUSTCOHORT"] = "ADJUSTCOHORT";
    CredsProvider["CROSSINSTALL"] = "CROSSINSTALL";
})(CredsProvider = exports.CredsProvider || (exports.CredsProvider = {}));
var CredsProviderHelpers = (function () {
    function CredsProviderHelpers() {
    }
    CredsProviderHelpers.isValid = function (value) {
        return CredsProviderHelpers.all.indexOf(value) >= 0;
    };
    CredsProviderHelpers.all = [
        CredsProvider.FACEBOOK,
        CredsProvider.FACEBOOKBUSINESS,
        CredsProvider.APPLOVIN,
        CredsProvider.GOOGLEADS,
        CredsProvider.IRONSOURCE,
        CredsProvider.IRONSOURCECOST,
        CredsProvider.IRONSOURCEBUSINESS,
        CredsProvider.IRONSOURCEADREVENUE,
        CredsProvider.ADCOLONY,
        CredsProvider.UNITY,
        CredsProvider.VUNGLE,
        CredsProvider.CHARTBOOST,
        CredsProvider.APPLESEARCH,
        CredsProvider.APPLESKAN,
        CredsProvider.TAPJOY,
        CredsProvider.TAPJOYV2,
        CredsProvider.TUNE,
        CredsProvider.KOCHAVA,
        CredsProvider.KOCHAVAAGGREGATED,
        CredsProvider.LIFESTREET,
        CredsProvider.APPLIKE,
        CredsProvider.DIGITALTURBINE,
        CredsProvider.APPLOVINMAX,
        CredsProvider.APPLOVINUSERREVENUE,
        CredsProvider.APPLOVINPROFIT,
        CredsProvider.ADJUST,
        CredsProvider.ADJUSTMMP,
        CredsProvider.ADJUSTSKAN,
        CredsProvider.ADJUSTCOHORT,
        CredsProvider.CROSSINSTALL
    ];
    return CredsProviderHelpers;
}());
exports.CredsProviderHelpers = CredsProviderHelpers;
var irt_1 = require("@playq/irt");
irt_1.Introspector.register('net.playq.services.common.adhawk.CredsProvider', {
    full: 'net.playq.services.common.adhawk.CredsProvider',
    short: 'CredsProvider',
    package: 'net.playq.services.common.adhawk',
    type: irt_1.IntrospectorTypes.Enum,
    options: CredsProviderHelpers.all
});
//# sourceMappingURL=CredsProvider.js.map